import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=b48f8ecc&"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=b48f8ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports